// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AutosubmitController from "./autosubmit_controller"
application.register("autosubmit", AutosubmitController)

import DuplicateController from "./duplicate_controller"
application.register("duplicate", DuplicateController)

import EventTypes__AvailibilityController from "./event_types/availibility_controller"
application.register("event-types--availibility", EventTypes__AvailibilityController)

import EventTypes__SelectTimezoneController from "./event_types/select_timezone_controller"
application.register("event-types--select-timezone", EventTypes__SelectTimezoneController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import OffcanvasController from "./offcanvas_controller"
application.register("offcanvas", OffcanvasController)

import PaddleController from "./paddle_controller"
application.register("paddle", PaddleController)

import PricingController from "./pricing_controller"
application.register("pricing", PricingController)

import PricingItemController from "./pricing_item_controller"
application.register("pricing-item", PricingItemController)

import RemovableController from "./removable_controller"
application.register("removable", RemovableController)

import StickyNavbarController from "./sticky_navbar_controller"
application.register("sticky-navbar", StickyNavbarController)
